import formatters from "helpers/formatters.jsx";
import {DataTable} from "components/dataTable/index.jsx";
import {useAppDataStore} from "@/mobx/appDataStore.jsx";
import moment from "moment";
import {useEffect, useMemo, useState} from "react";
import {Button} from "react-aria-components";

export default function Providers(props) {
  const appDataStore = useAppDataStore()
  const [balances, setBalances] = useState([])
  const [refreshDependence,setRefreshDependence] = useState()

  const columns = useMemo(() => ([
    {
      accessorKey: 'user',
      header: 'Usuario',
    },
    {
      accessorKey: 'password',
      header: 'Contraseña',
      enableColumnFilter: false,
    },
    {
      accessorKey: 'user',
      header: 'Saldo',
      enableColumnFilter: false,
      cell: (data) => {
        const user = data.getValue()
        if (!balances.connections) return <>
          Cargando...
        </>
        const balanceInfo = balances.connections.find(balance => balance.account === user)
        if (!balanceInfo) return <div className={'text-red-600'}>sin información</div>
        if (balanceInfo.balance > 300000)
          return <div className={`text-green-800`}>{formatters.number(balanceInfo.balance)}</div>
        return <div className={`text-red-800`}>{formatters.number(balanceInfo.balance)}</div>

      }
    },
    {
      accessorKey: 'enabled',
      header: 'habilitado',
      enableColumnFilter: false,
      cell: (data) => {
        const value = data.getValue()
        return value ? 'SI' : 'NO'
      }
    },
    {
      accessorKey: '',
      header: 'reconectar',
      enableColumnFilter: false,
      cell: ({row}) => {
        return <Button onPress={() => reconnect(row.original.id)}>reconectar</Button>
      }
    },
  ]), [balances])

  const dataFetch = async (
    records,
    currentPage,
    order,
    search,
    filter,
    attributes
  ) => {
    return appDataStore.post(`/app/datasource/Provider`, {
        records,
        currentPage,
        order,
        search,
        filter,
        attributes,
        or: appDataStore.user.Providers.map(provider => ({
          key: 'user',
          value: provider.user,
          operator: 'eq'
        })),
        searchAttributes: ['user']
      }
    );
  }

  const reconnect = async (id) => {
    try {
      const res = await appDataStore.post(`/app/providers/${id}/login`, {})
      alert(res.login)
      setRefreshDependence(moment())
      await fetchBalances()
    } catch (err) {
      setRefreshDependence(moment())
      alert(err.message)
    }
  }

  const fetchBalances = async () => {
    const balances = await appDataStore.post(`/app/providers/balance`, {})
    setBalances(balances)
  }

  useEffect(() => {
    fetchBalances().then()
    const timer = setInterval(() => {
      fetchBalances().then()
    }, 60000)
    return () => {
      clearInterval(timer)
    }
  }, []);
  return (
    <>
      <DataTable columns={columns} dataFetch={dataFetch} exportFileName={'cuentas_tigo_gestion'} refreshDependencies={[refreshDependence]}/>
    </>
  )
}